module.exports = function ($filter, settings) {
    return function (packagingPreference, collapsed = false) {
        if (settings.checkout.enablePackagingUnitPricing && !packagingPreference.IsFlatFee) {
            return collapsed
                ? `(approx ${packagingPreference.EstimatedCount} &times; ${$filter('wowCurrencyCents')(packagingPreference.UnitCost)} each)`
                : `<div>approx ${packagingPreference.EstimatedCount}</div><div>(${$filter('wowCurrencyCents')(packagingPreference.UnitCost)} each)</div>`;
        }
        return 'Per order';
    };
};



// WEBPACK FOOTER //
// ./src/common/filters/wow-packaging-price-label.js